<template>
  <!-- BEGIN: Content-->
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      v-if="user.id"
      class="content-wrapper"
    >
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top profile__avatar">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                {{ user.roles.some(e => e.name == 'super-admin') && $route.name != 'admin.occupational-hazards.index' ? 'CAE' : 'Occupational Safety and Health (OSH)' }}
              </h2>
            </div>
          </div>
        </div>
        <div
          class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none"
        >
          <div class="mb-1 breadcrumb-right">
            <span
              class="dis-ib ms-50"
              title="Search documents"
              @click="openFilters"
            >
              <a
                class="btn btn-icon btn-primary"
              ><i data-feather="search" /></a>
            </span>
            <a
              v-if="(user.roles.some(e => e.name == 'super-admin') && $route.name != 'admin.occupational-hazards.index') || user.roles.some(e => e.name == 'cae')"
              class="btn btn-icon btn-primary ms-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Upload file"
              :href="$router.resolve({name: 'cae.labour-hazards.create', query: { actAs: $route.query.actAs }}).href"
              target="_blank"
            ><i data-feather="upload" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div class="row">
          <div
            v-if="user.roles.some(e => e.name == 'super-admin') && $route.name != 'admin.occupational-hazards.index'"
            class="col-12"
          >
            <SelectInstitution />
          </div>

          <div class="col-12">
            <b-tabs
              v-if="!loading"
              lazy
            >
              <b-tab
                active
              >
                <template #title>
                  Section & Subsections
                </template>

                <div class="row">
                  <div class="col-sm-6">
                    <v-select
                      :placeholder="'Search section or subsection'"
                      label="name"
                      :options="sections"
                      :get-option-key="option => option.id"
                      @input="selectedSection"
                    />
                  </div>
                </div>
                <hr>
                <div
                  class="row"
                >
                  <div
                    v-for="section in filteredSections"
                    :key="section.id"
                    class="col-4"
                  >
                    <CaeSection :section="section" />
                  </div>
                </div>
              </b-tab>
              <b-tab v-if="user.roles.some(e => e.name == 'super-admin') && $route.name != 'admin.occupational-hazards.index' || user.roles.some(e => e.name == 'cae')">
                <template #title>
                  ICREA'S
                </template>
                <div class="row">
                  <div class="col-sm-6">
                    <v-select
                      :placeholder="'Search icreas'"
                      label="name"
                      :options="icreas"
                      :get-option-key="option => option.id"
                      @input="selectedIcreaR"
                    />
                  </div>
                </div>
                <hr>
                <div
                  class="row"
                >
                  <div
                    v-for="icrea in filteredIcreas"
                    :key="icrea.id"
                    class="col-sm-4 row-cae-card--container"
                  >
                    <CaeIcrea :icrea="icrea" />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
            <div v-if="loading">
              <div class="loading custom-loading">
                <div class="effect-1 effects" />
                <div class="effect-2 effects" />
                <div class="effect-3 effects" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Search />
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BTab, BTabs,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SelectInstitution from './partials/SelectInstitution.vue'
import CaeSection from './partials/CaeSection.vue'
import CaeIcrea from './partials/CaeIcrea.vue'
import Search from './partials/Search.vue'
import { watch } from 'vue'

export default {
  components: {
    BTab,
    BTabs,
    SelectInstitution,
    vSelect,
    CaeSection,
    CaeIcrea,
    Search,
  },
  data() {
    return {
      selected: null,
      selectedIcrea: null,
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      sections: 'cae/items',
      icreas: 'cae/icreas',
      caeInstitution: 'cae/institution',
      loading: 'cae/loading',
      filters: 'filters/filters',
      loggedUser: 'auth/admin',
      user: 'users/user',
    }),
    filteredSections() {
      return this.sections.filter(e => !this.selected || e.id === this.selected.id)
    },
    filteredIcreas() {
      return this.icreas.filter(e => !this.selectedIcrea || e.id === this.selectedIcrea.id)
    },
  },
  watch: {
    caeInstitution: {
      handler: 'loadData',
      deep: true,
    },
  },
  async mounted() {
    await this.$store.dispatch('cae/clear')
    if (this.$route.query.prefilterUser && this.loggedUser.roles.includes('super-admin')) {
      await this.$store.dispatch('users/fetchUser', this.$route.query.prefilterUser)
    } else {
      await this.$store.dispatch('users/fetchUser', this.loggedUser.id)
    }

    if (this.user.roles.some(e => e.name === 'cae')) {
      this.$store.dispatch('cae/toggleLoading', true)
      await this.loadData()
    } else if (this.user.roles.some(e => e.name === 'super-admin') && this.$route.name === 'admin.occupational-hazards.index') {
      await this.$store.dispatch('cae/fetch', this.filters)
    } else if (this.user.roles.some(e => e.name === 'researcher')) {
      this.$store.dispatch('cae/saveInstitution', this.user.hosts[0])
      await this.$store.dispatch('cae/fetch', this.filters)
    }

    this.$store.dispatch('cae/toggleLoading', false)
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    async loadData() {
      this.$store.dispatch('filters/saveFilters', {
        value: this.caeInstitution ? this.caeInstitution : null,
        field: 'host',
      })

      await this.$store.dispatch('cae/fetch', this.filters)
      await this.$store.dispatch('cae/fetchIcreas', this.filters)
    },
    selectedSection(item) {
      this.selected = item
    },
    selectedIcreaR(item) {
      this.selectedIcrea = item
    },
    openFilters() {
      this.$store.dispatch('modals/toggleConvoFilters', true)
    },
  },
}
</script>
